export default [
  {
    id: 417,
    imageUrl: '/assets/images/covers/TA1-SB.png',
    externalLink: 'https://faf1.sachso.edu.vn',
    title: 'Tiếng Anh 1',
    subTitle: 'Family and Friends National Edition',
    description: 'Student Book',
    sortOrder: 1,
    schoolTypeId: 1,
    classId: 1,
    bookType: 'sb',
  },
  {
    id: 10899,
    imageUrl: '/assets/images/covers/TA1-WB.png',
    externalLink: 'https://faf1-wb.sachso.edu.vn',
    title: 'Tiếng Anh 1',
    subTitle: 'Family and Friends National Edition',
    description: 'Workbook',
    sortOrder: 2,
    schoolTypeId: 1,
    classId: 1,
    bookType: 'wb',
  },
  {
    id: 10765,
    imageUrl: '/assets/images/covers/TA2-SB.png',
    externalLink: 'https://faf2.sachso.edu.vn',
    title: 'Tiếng Anh 2',
    subTitle: 'Family and Friends National Edition',
    description: 'Student Book',
    sortOrder: 3,
    schoolTypeId: 1,
    classId: 2,
    bookType: 'sb',
  },
  {
    id: 10811,
    imageUrl: '/assets/images/covers/TA2-WB.png',
    externalLink: 'https://faf2-wb.sachso.edu.vn',
    title: 'Tiếng Anh 2',
    subTitle: 'Family and Friends National Edition',
    description: 'Workbook',
    sortOrder: 4,
    schoolTypeId: 1,
    classId: 2,
    bookType: 'wb',
  },
  {
    id: 10984,
    imageUrl: '/assets/images/covers/TA3-SB.jpg',
    externalLink: 'https://faf3-sb-old.sachso.edu.vn',
    title: 'Tiếng Anh 3',
    subTitle: 'Family and Friends Special Edition',
    description: 'Student Book',
    sortOrder: 5,
    schoolTypeId: 1,
    classId: 3,
    bookType: 'sb',
    isNew: true,
  },
  {
    id: 11302,
    imageUrl: '/assets/images/covers/TA3-WB.jpg',
    externalLink: 'https://faf3-wb-old.sachso.edu.vn',
    title: 'Tiếng Anh 3',
    subTitle: 'Family and Friends Special Edition',
    description: 'Workbook',
    sortOrder: 6,
    schoolTypeId: 1,
    classId: 3,
    bookType: 'wb',
    isNew: true,
  },
  {
    id: 10984,
    imageUrl: '/assets/images/covers/TA3-SB-V2.png',
    externalLink: 'https://faf3-sb-v2.sachso.edu.vn',
    title: 'Tiếng Anh 3',
    // subTitle: 'Family and Friends National Edition',
    subTitle: 'Family and Friends National Edition',
    description: 'Student Book',
    sortOrder: 29,
    schoolTypeId: 1,
    classId: 3,
    bookType: 'sb',
    // isNew: true,
  },
  {
    id: 11302,
    imageUrl: '/assets/images/covers/TA3-WB-V2.png',
    externalLink: 'https://faf3-wb-v2.sachso.edu.vn',
    title: 'Tiếng Anh 3',
    // subTitle: 'Family and Friends National Edition',
    subTitle: 'Family and Friends National Edition',
    description: 'Workbook',
    sortOrder: 30,
    schoolTypeId: 1,
    classId: 3,
    bookType: 'wb',
    // isNew: true,
  },
  {
    id: 11306,
    imageUrl: '/assets/images/covers/TA4-SB.jpg',
    externalLink: 'https://faf4-sb-old.sachso.edu.vn',
    title: 'Tiếng Anh 4',
    subTitle: 'SB Family and Friends Special Edition',
    description: 'Student Book',
    sortOrder: 7,
    schoolTypeId: 1,
    classId: 4,
    bookType: 'sb',
    isNew: true,
  },
  {
    id: 11307,
    imageUrl: '/assets/images/covers/TA4-WB.jpg',
    externalLink: 'https://faf4-wb-old.sachso.edu.vn/',
    title: 'Tiếng Anh 4',
    subTitle: 'WB Family and Friends Special Edition',
    description: 'Workbook',
    sortOrder: 8,
    schoolTypeId: 1,
    classId: 4,
    bookType: 'wb',
    isNew: true,
  },
  {
    id: 11308,
    imageUrl: '/assets/images/covers/TA5-SB.jpg',
    // externalLink: 'https://faf5.sachso.edu.vn',
    externalLink: 'https://faf5-sb-v1.sachso.edu.vn',
    title: 'Tiếng Anh 5',
    widthSubTitle: '90%',
    marginLeft: '12px',
    subTitle: 'Family and Friends Special Edition',
    description: 'Student Book',
    sortOrder: 9,
    schoolTypeId: 1,
    classId: 5,
    bookType: 'sb',
    isNew: true,
  },
  {
    id: 11309,
    imageUrl: '/assets/images/covers/TA5-WB.jpg',
    // externalLink: 'https://faf5-wb.sachso.edu.vn',
    externalLink: 'https://faf5-wb-v1.sachso.edu.vn',
    title: 'Tiếng Anh 5',
    widthSubTitle: '90%',
    marginLeft: '12px',
    subTitle: 'Family and Friends Special Edition',
    description: 'Workbook',
    sortOrder: 10,
    schoolTypeId: 1,
    classId: 5,
    bookType: 'wb',
    isNew: true,
  },
  // {
  //   id: 11312,
  //   imageUrl: '/assets/images/covers/TA5-SB.jpg',
  //   // externalLink: 'https://faf5.sachso.edu.vn',
  //   externalLink: 'https://faf5-sb-v2-old.sachso.edu.vn',
  //   title: 'Tiếng Anh 5',
  //   widthSubTitle: '90%',
  //   marginLeft: '12px',
  //   subTitle: 'Family and Friends Special Edition',
  //   description: 'Student Book',
  //   sortOrder: 9,
  //   schoolTypeId: 1,
  //   classId: 5,
  //   bookType: 'sb',
  //   isNew: true,
  // },
  // {
  //   id: 11314,
  //   imageUrl: '/assets/images/covers/TA5-WB.jpg',
  //   // externalLink: 'https://faf5-wb.sachso.edu.vn',
  //   externalLink: 'https://faf5-wb-v2-old.sachso.edu.vn',
  //   title: 'Tiếng Anh 5',
  //   widthSubTitle: '90%',
  //   marginLeft: '12px',
  //   subTitle: 'Family and Friends Special Edition',
  //   description: 'Workbook',
  //   sortOrder: 10,
  //   schoolTypeId: 1,
  //   classId: 5,
  //   bookType: 'wb',
  //   isNew: true,
  // },
  {
    id: 10794,
    imageUrl: '/assets/images/covers/TA6-SB.png',
    externalLink: 'https://fp6.sachso.edu.vn',
    title: 'Tiếng Anh 6',
    subTitle: 'Friends Plus',
    description: 'Student Book',
    sortOrder: 11,
    schoolTypeId: 2,
    classId: 6,
    bookType: 'sb',
  },
  {
    id: 10898,
    imageUrl: '/assets/images/covers/TA6-WB.png',
    externalLink: 'https://fp6-wb.sachso.edu.vn',
    title: 'Tiếng Anh 6',
    subTitle: 'Friends Plus',
    description: 'Workbook',
    sortOrder: 12,
    schoolTypeId: 2,
    classId: 6,
    bookType: 'wb',
  },
  {
    id: 11019,
    imageUrl: '/assets/images/covers/TA7-SB.png',
    externalLink: 'https://fp7-sb.sachso.edu.vn',
    title: 'Tiếng Anh 7',
    subTitle: 'Friends Plus',
    description: 'Student Book',
    sortOrder: 13,
    schoolTypeId: 2,
    classId: 7,
    bookType: 'sb',
    // isNew: true,
  },
  {
    id: 11304,
    imageUrl: '/assets/images/covers/TA7-WB.jpg',
    externalLink: 'https://fp7-wb.sachso.edu.vn',
    title: 'Tiếng Anh 7',
    subTitle: 'Friends Plus',
    description: 'Workbook',
    sortOrder: 14,
    schoolTypeId: 2,
    classId: 7,
    bookType: 'wb',
    // isNew: true,
  },
  {
    id: 11467,
    imageUrl: '/assets/images/covers/TA8-SB-Demo2023.jpg',
    externalLink: 'https://fp8-sb-2023.sachso.edu.vn',
    title: 'Tiếng Anh 8',
    subTitle: 'Friends Plus',
    description: 'Student Book',
    sortOrder: 15,
    schoolTypeId: 2,
    classId: 8,
    bookType: 'sb',
    // isNew: true,
  },
  {
    id: 51184,
    imageUrl: '/assets/images/covers/TA8-WB-Demo2023.jpg',
    externalLink: 'https://fp8-wb-2023.sachso.edu.vn',
    title: 'Tiếng Anh 8',
    subTitle: 'Friends Plus',
    description: 'Workbook',
    sortOrder: 16,
    schoolTypeId: 2,
    classId: 8,
    bookType: 'wb',
    // isNew: true,
  },
  {
    id: 51185,
    imageUrl: '/assets/images/covers/TA9-SB-2024.jpg',
    externalLink: 'https://fp9-sb-2024.sachso.edu.vn',
    title: 'Tiếng Anh 9',
    subTitle: 'Friends Plus',
    description: 'Student book',
    sortOrder: 17,
    schoolTypeId: 2,
    classId: 9,
    bookType: 'sb',
    // isNew: true,
  },
  // {
  //   id: 51187,
  //   imageUrl: '/assets/images/covers/TA9-SB-2024.jpg',
  //   externalLink: 'https://fp9-sb-demo-2024.sachso.edu.vn',
  //   title: 'Unit tham khảo',
  //   subTitle: '',
  //   description: 'Student book',
  //   sortOrder: 18,
  //   schoolTypeId: 2,
  //   classId: 9,
  //   bookType: 'sb',
  //   isNew: true,
  // },
  {
    id: 51186,
    imageUrl: '/assets/images/covers/TA9-WB-2024.jpg',
    externalLink: 'https://fp9-wb-2024.sachso.edu.vn',
    title: 'Tiếng Anh 9',
    subTitle: 'Friends Plus',
    description: 'Workbook',
    sortOrder: 19,
    schoolTypeId: 2,
    classId: 9,
    bookType: 'wb',
    // isNew: true,
  },
  // {
  //   id: 51188,
  //   imageUrl: '/assets/images/covers/TA9-WB-2024.jpg',
  //   externalLink: 'https://fp9-wb-demo-2024.sachso.edu.vn',
  //   title: 'Unit tham khảo',
  //   subTitle: '',
  //   description: 'Workbook',
  //   sortOrder: 20,
  //   schoolTypeId: 2,
  //   classId: 9,
  //   bookType: 'wb',
  //   isNew: true,
  // },
  {
    id: 11102,
    imageUrl: '/assets/images/covers/TA10-SB.png',
    externalLink: 'https://fg10-sb.sachso.edu.vn',
    title: 'Tiếng Anh 10',
    subTitle: 'Friends Global',
    description: 'Student Book',
    sortOrder: 21,
    schoolTypeId: 3,
    classId: 10,
    bookType: 'sb',
    // isNew: true,
  },
  {
    id: 11315,
    imageUrl: '/assets/images/covers/TA10-WB.jpg',
    externalLink: 'https://fg10-wb.sachso.edu.vn',
    title: 'Tiếng Anh 10',
    subTitle: 'Friends Global',
    description: 'Workbook',
    sortOrder: 22,
    schoolTypeId: 3,
    classId: 10,
    bookType: 'wb',
    // isNew: true,
  },
  {
    id: 21166,
    imageUrl: '/assets/images/covers/TA11-SB.jpg',
    externalLink: 'https://fp11-sb-2023.sachso.edu.vn',
    title: 'Tiếng Anh 11',
    subTitle: 'Friends Global',
    description: 'Student Book',
    sortOrder: 23,
    schoolTypeId: 3,
    classId: 11,
    bookType: 'sb',
    // isNew: true,
  },
  {
    id: 21167,
    imageUrl: '/assets/images/covers/TA11-WB.jpg',
    externalLink: 'https://fp11-wb-2023.sachso.edu.vn',
    title: 'Tiếng Anh 11',
    subTitle: 'Friends Global',
    description: 'Workbook',
    sortOrder: 24,
    schoolTypeId: 3,
    classId: 11,
    bookType: 'wb',
    // isNew: true,
  },
  {
    id: 21169,
    imageUrl: '/assets/images/covers/TA12-SB.jpg',
    externalLink: 'https://fp12-sb-2024.sachso.edu.vn',
    title: 'Tiếng Anh 12',
    subTitle: 'Friends Global',
    description: 'Student Book',
    sortOrder: 25,
    schoolTypeId: 3,
    classId: 12,
    bookType: 'sb',
    // isNew: true,
  },
  // {
  //   id: 21170,
  //   imageUrl: '/assets/images/covers/TA12-SB.jpg',
  //   externalLink: 'https://fp12-sb-demo-2024.sachso.edu.vn',
  //   title: 'Unit tham khảo',
  //   subTitle: '',
  //   description: 'Student Book',
  //   sortOrder: 26,
  //   schoolTypeId: 3,
  //   classId: 12,
  //   bookType: 'sb',
  //   isNew: true,
  // },
  {
    id: 21168,
    imageUrl: '/assets/images/covers/TA12-WB.jpg',
    externalLink: 'https://fp12-wb-2024.sachso.edu.vn',
    title: 'Tiếng Anh 12',
    subTitle: 'Friends Global',
    description: 'Workbook',
    sortOrder: 27,
    schoolTypeId: 3,
    classId: 12,
    bookType: 'wb',
    // isNew: true,
  },
  // {
  //   id: 21171,
  //   imageUrl: '/assets/images/covers/TA12-WB.jpg',
  //   externalLink: 'https://fp12-wb-demo-2024.sachso.edu.vn',
  //   title: 'Unit tham khảo',
  //   subTitle: '',
  //   description: 'Workbook',
  //   sortOrder: 28,
  //   schoolTypeId: 3,
  //   classId: 12,
  //   bookType: 'wb',
  //   isNew: true,
  // },
  // ////////// ////////// ////////// ////////// //////////
  {
    id: 11310,
    imageUrl: '/assets/images/covers/TA4-SB-V2.jpg',
    externalLink: 'https://faf4-sb-v2-old.sachso.edu.vn',
    title: 'Tiếng Anh 4',
    subTitle: 'SB Family and Friends National Edition - Version 2',
    description: 'Student Book',
    sortOrder: 31,
    schoolTypeId: 1,
    classId: 4,
    bookType: 'sb',
    isNew: true,
  },
  {
    id: 11313,
    imageUrl: '/assets/images/covers/TA4-WB-V2.jpg',
    externalLink: 'https://faf4-wb-v2-old.sachso.edu.vn',
    title: 'Tiếng Anh 4',
    subTitle: 'WB Family and Friends National Edition - Version 2',
    description: 'WorkBook',
    sortOrder: 32,
    schoolTypeId: 1,
    classId: 4,
    bookType: 'wb',
    isNew: true,
  },
  // {
  //   id: 21171,
  //   imageUrl: '/assets/images/covers/TA12-WB.jpg',
  //   externalLink: 'https://fp12-wb-demo-2024.sachso.edu.vn',
  //   title: 'Unit tham khảo',
  //   subTitle: '',
  //   description: 'Workbook',
  //   sortOrder: 28,
  //   schoolTypeId: 3,
  //   classId: 12,
  //   bookType: 'wb',
  //   isNew: true,
  // },
  // ////////// ////////// ////////// ////////// //////////
  // {
  //   id: 11310,
  //   imageUrl: '/assets/images/covers/TA4-SB-V2.jpg',
  //   externalLink: 'https://faf4-sb-v2.sachso.edu.vn',
  //   title: 'Tiếng Anh 4',
  //   subTitle: 'SB Family and Friends National Edition - Version 2',
  //   description: 'Student Book',
  //   sortOrder: 31,
  //   schoolTypeId: 1,
  //   classId: 4,
  //   bookType: 'sb',
  //   // isNew: true,
  // },
  // {
  //   id: 11313,
  //   imageUrl: '/assets/images/covers/TA4-WB-V2.jpg',
  //   externalLink: 'https://faf4-wb-v2.sachso.edu.vn',
  //   title: 'Tiếng Anh 4',
  //   subTitle: 'WB Family and Friends National Edition - Version 2',
  //   description: 'WorkBook',
  //   sortOrder: 32,
  //   schoolTypeId: 1,
  //   classId: 4,
  //   bookType: 'wb',
  //   // isNew: true,
  // },
  // {
  //   id: 29497,
  //   imageUrl: '/assets/images/covers/TA4-SB2023.jpg',
  //   externalLink: 'https://faf4-sb-2023.sachso.edu.vn',
  //   title: 'Tiếng Anh 4',
  //   subTitle: 'SB Family and Friends National Edition 2023',
  //   description: 'Student Book',
  //   sortOrder: 33,
  //   schoolTypeId: 1,
  //   classId: 4,
  //   bookType: 'sb',
  //   // isNew: true,
  // },
  {
    id: 11468,
    imageUrl: '/assets/images/covers/TA4-SB-Demo2023.jpg',
    externalLink: 'https://faf4-sb-2023.sachso.edu.vn',
    title: 'Tiếng Anh 4',
    subTitle: 'Family and Friends National Edition',
    description: 'Student Book',
    sortOrder: 34,
    schoolTypeId: 1,
    classId: 4,
    bookType: 'sb',
    // isNew: true,
  },
  {
    id: 151296,
    imageUrl: '/assets/images/covers/TA4-WB-Demo2023.jpg',
    externalLink: 'https://faf4-wb-2023.sachso.edu.vn',
    title: 'Tiếng Anh 4',
    subTitle: 'Family and Friends National Edition',
    description: 'Workbook',
    sortOrder: 35,
    schoolTypeId: 1,
    classId: 4,
    bookType: 'wb',
    // isNew: true,
  },
  {
    id: 11312,
    imageUrl: '/assets/images/covers/TA5-SB-V2.jpg',
    externalLink: 'https://faf5-sb-v2-old.sachso.edu.vn',
    title: 'Tiếng Anh 5',
    subTitle: 'Family and Friends Special Edition - Version 2',
    description: 'Student Book',
    sortOrder: 37,
    schoolTypeId: 1,
    classId: 5,
    bookType: 'sb',
    isNew: true,
  },
  {
    id: 11314,
    imageUrl: '/assets/images/covers/TA5-WB-V2.jpg',
    externalLink: 'https://faf5-wb-v2-old.sachso.edu.vn',
    title: 'Tiếng Anh 5',
    subTitle: 'Family and Friends Special Edition - Version 2',
    description: 'Workbook',
    sortOrder: 38,
    schoolTypeId: 1,
    classId: 5,
    bookType: 'wb',
    isNew: true,
  },
  {
    id: 11316,
    imageUrl: '/assets/images/covers/TA5-SB-2024.jpg',
    externalLink: 'https://faf5-sb-2024.sachso.edu.vn',
    title: 'Tiếng Anh 5',
    subTitle: 'Family and Friends National Edition',
    description: 'Student book',
    sortOrder: 39,
    schoolTypeId: 1,
    classId: 5,
    bookType: 'sb',
    // isNew: true,
  },
  // {
  //   id: 11318,
  //   imageUrl: '/assets/images/covers/TA5-SB-2024.jpg',
  //   externalLink: 'https://faf5-sb-demo-2024.sachso.edu.vn',
  //   title: 'Unit tham khảo',
  //   subTitle: '',
  //   description: 'Student book',
  //   sortOrder: 40,
  //   schoolTypeId: 1,
  //   classId: 5,
  //   bookType: 'sb',
  //   isNew: true,
  // },
  {
    id: 11317,
    imageUrl: '/assets/images/covers/TA5-WB-2024.jpg',
    externalLink: 'https://faf5-wb-2024.sachso.edu.vn',
    title: 'Tiếng Anh 5 Family and Friends National Edition',
    subTitle: '',
    description: 'Workbook',
    sortOrder: 41,
    schoolTypeId: 1,
    classId: 5,
    bookType: 'wb',
    // isNew: true,
  },
  // {
  //   id: 11319,
  //   imageUrl: '/assets/images/covers/TA5-WB-2024.jpg',
  //   externalLink: 'https://faf5-wb-demo-2024.sachso.edu.vn',
  //   title: 'Unit tham khảo',
  //   subTitle: '',
  //   description: 'Workbook',
  //   sortOrder: 42,
  //   schoolTypeId: 1,
  //   classId: 5,
  //   bookType: 'wb',
  //   isNew: true,
  // },
  // ////////// ////////// ////////// ////////// //////////
  {
    id: 100000,
    imageUrl: '/assets/images/covers/mamnon1.png',
    externalLink: 'https://mn1.sachso.edu.vn',
    title: 'LÀM QUEN TIẾNG ANH - Quyển 1',
    subTitle: '',
    description: '(dành cho lứa tuổi mẫu giáo)',
    sortOrder: 56,
    schoolTypeId: 0, // Cấp mầm non.
    classId: 0,
    bookType: 'sb',
    // isNew: true,
  },
  {
    id: 200000,
    imageUrl: '/assets/images/covers/mamnon2.png',
    externalLink: 'https://mn2.sachso.edu.vn',
    title: 'LÀM QUEN TIẾNG ANH - Quyển 2',
    subTitle: '',
    description: '(dành cho lứa tuổi mẫu giáo)',

    sortOrder: 57,
    schoolTypeId: 0, // Cấp mầm non.
    classId: 0,
    bookType: 'sb',
    // isNew: true,
  },
  {
    id: 300000,
    imageUrl: '/assets/images/covers/mamnon3.png',
    externalLink: 'https://mn3.sachso.edu.vn',
    title: 'LÀM QUEN TIẾNG ANH - Quyển 3',
    subTitle: '',
    description: '(dành cho lứa tuổi mẫu giáo)',
    sortOrder: 58,
    schoolTypeId: 0, // Cấp mầm non.
    classId: 0,
    bookType: 'sb',
    // isNew: true,
  },
  // {
  //   id: 300023,
  //   imageUrl: '/assets/images/covers/GD-Stem-lop1.jpg',
  //   // externalLink: 'https://stem1.sachdientu.cloud',
  //   externalLink: 'https://gd-stem-lop1-old.sachso.edu.vn',
  //   title: 'Giáo dục Stem - Lớp 1',
  //   subTitle: '',
  //   description: '(dành cho lứa tuổi mẫu giáo)',
  //   sortOrder: 64,
  //   schoolTypeId: 0, // Cấp mầm non.
  //   classId: 1,
  //   bookType: 'sb',
  //   isNew: true,
  // },
  // {
  //   id: 300024,
  //   imageUrl: '/assets/images/covers/GD-Stem-lop2.jpg',
  //   externalLink: 'https://stem2.sachdientu.cloud',
  //   title: 'Giáo dục Stem - Lớp 2',
  //   subTitle: '',
  //   description: '(dành cho lứa tuổi mẫu giáo)',
  //   sortOrder: 65,
  //   schoolTypeId: 0, // Cấp mầm non.
  //   classId: 2,
  //   bookType: 'sb',
  //   // isNew: true,
  // },
  // {
  //   id: 300025,
  //   imageUrl: '/assets/images/covers/GD-Stem-lop3.jpg',
  //   externalLink: 'https://stem2.sachdientu.cloud',
  //   title: 'Giáo dục Stem - Lớp 3',
  //   subTitle: '',
  //   description: '(dành cho lứa tuổi mẫu giáo)',
  //   sortOrder: 66,
  //   schoolTypeId: 0, // Cấp mầm non.
  //   classId: 3,
  //   bookType: 'sb',
  //   // isNew: true,
  // },
  // {
  //   id: 300026,
  //   imageUrl: '/assets/images/covers/GD-Stem-lop4.jpg',
  //   externalLink: 'https://stem2.sachdientu.cloud',
  //   title: 'Giáo dục Stem - Lớp 4',
  //   subTitle: '',
  //   description: '(dành cho lứa tuổi mẫu giáo)',
  //   sortOrder: 67,
  //   schoolTypeId: 0, // Cấp mầm non.
  //   classId: 4,
  //   bookType: 'sb',
  //   // isNew: true,
  // },
  // {7
  //   id: 300027,
  //   imageUrl: '/assets/images/covers/GD-Stem-lop5.jpg',
  //   externalLink: 'https://stem2.sachdientu.cloud',
  //   title: 'Giáo dục Stem - Lớp 5',
  //   subTitle: '',
  //   description: '(dành cho lứa tuổi mẫu giáo)',
  //   sortOrder: 68,
  //   schoolTypeId: 0, // Cấp mầm non.
  //   classId: 5,
  //   bookType: 'sb',
  //   // isNew: true,
  // },
  // {
  //   id: 300028,
  //   imageUrl: '/assets/images/covers/T4-SB.jpg',
  //   // externalLink: 'https://stem1.sachdientu.cloud',
  //   externalLink: 'https://sachtoan4-old.sachso.edu.vn',
  //   title: 'Toán 4',
  //   subTitle: 'Tập 1',
  //   description: '',
  //   sortOrder: 69,
  //   schoolTypeId: 0, // Cấp mầm non.
  //   classId: 4,
  //   bookType: 'sb',
  //   isNew: true,
  // },
  // {
  //   id: 300029,
  //   imageUrl: '/assets/images/covers/T4-WB.jpg',
  //   // externalLink: 'https://stem1.sachdientu.cloud',
  //   externalLink: 'https://sachtoan4-bt-old.sachso.edu.vn',
  //   title: 'Toán 4',
  //   subTitle: 'Tập 1',
  //   description: 'Vở bài tập',
  //   sortOrder: 70,
  //   schoolTypeId: 0, // Cấp mầm non.
  //   classId: 4,
  //   bookType: 'wb',
  //   isNew: true,
  // },
  // {
  //   id: 300030,
  //   imageUrl: '/assets/images/covers/TV4-SB.jpg',
  //   // externalLink: 'https://stem1.sachdientu.cloud',
  //   externalLink: 'https://tiengviet4-old.sachso.edu.vn',
  //   title: 'Tiếng Việt 4',
  //   subTitle: 'Tập 1',
  //   description: '',
  //   sortOrder: 71,
  //   schoolTypeId: 0, // Cấp mầm non.
  //   classId: 4,
  //   bookType: 'sb',
  //   isNew: true,
  // },
  // {
  //   id: 300031,
  //   imageUrl: '/assets/images/covers/TV4-WB.jpg',
  //   // externalLink: 'https://stem1.sachdientu.cloud',
  //   externalLink: 'https://tiengviet4-bt-old.sachso.edu.vn/',
  //   title: 'Tiếng Việt 4',
  //   subTitle: 'Tập 1',
  //   description: 'Vở bài tập',
  //   sortOrder: 72,
  //   schoolTypeId: 0, // Cấp mầm non.
  //   classId: 4,
  //   bookType: 'wb',
  //   isNew: true,
  // },
];
